import { Layout } from 'antd';
import React from 'react';
import '../../App.css';
import { DashboardLayout } from '../../components/DashboardLayout/DashboardLayout';
import AdminDashboardRouter from '../../AdminRoutes';
import options from '../SideBar/options';
import SideBar from '../SideBar/SideBar';

const { Content } = Layout;

class AdminDashboard extends React.Component {
  render = () => (
    <>
      <SideBar urlPrefix='dashboard' nextUrlPrefix='app' options={options} />
      <Layout
        style={{
          minHeight: '100vh',
          background: '#D9D8D0'
        }}
      >
        <Content>
          <div style={{ padding: 24, paddingTop: 80, minHeight: 360 }}>
            <AdminDashboardRouter />
          </div>
          {process.env.REACT_APP_VERSION && (
            <div style={{ textAlign: 'center', color: '#ccc' }}>
              Versie #{process.env.REACT_APP_VERSION}
            </div>
          )}
        </Content>
      </Layout>
    </>
  );
}

export default DashboardLayout(AdminDashboard);
